document.addEventListener('DOMContentLoaded', function () {
  const flagImg = document.getElementById('current-lang-flag');

  // Default to EU flag
  const defaultFlag = 'https://cdn.shopify.com/s/files/1/0904/7120/3185/files/world.png?v=1742992825';
  if (flagImg) {
    flagImg.src = defaultFlag;
  }

  const flagMap = {
    DK: 'https://cdn.shopify.com/s/files/1/0904/7120/3185/files/denmark.png?v=1742990123',
    SE: 'https://cdn.shopify.com/s/files/1/0904/7120/3185/files/sweden.png?v=1742990968',
    NO: 'https://cdn.shopify.com/s/files/1/0904/7120/3185/files/norway.png?v=1742991092',
    FI: 'https://cdn.shopify.com/s/files/1/0904/7120/3185/files/findland.png?v=1742991571',
    DE: 'https://cdn.shopify.com/s/files/1/0904/7120/3185/files/germany.png?v=1742990123',
    FR: 'https://cdn.shopify.com/s/files/1/0904/7120/3185/files/france.png?v=1742992825',
    IT: 'https://cdn.shopify.com/s/files/1/0904/7120/3185/files/flag.png?v=1742992824',
    ES: 'https://cdn.shopify.com/s/files/1/0904/7120/3185/files/world.png?v=1742992825',
    NL: 'https://cdn.shopify.com/s/files/1/0910/4090/7587/files/netherlands.png?v=1746438517',
    EE: 'https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Estonia_svg.png?v=1746440898',
    LV: 'https://cdn.shopify.com/s/files/1/0910/4090/7587/files/latvia.png?v=1746441665',
    LT: 'https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Lithuania.png?v=1746448397',
    PL: 'https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Poland.png?v=1746447118',
    AT: 'https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Austria_svg.png?v=1746448445',
    BE: 'https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Belgium.png?v=1746448509',
    LU: 'https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Luxembourg_svg.png?v=1746448566',
    CZ: 'https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_the_Czech_Republic_svg.webp?v=1746448625'
  };

  // Try updating the flag once Shopify.country becomes available
  function updateFlagWhenReady(retries = 10) {
    const countryCode = Shopify && Shopify.country ? Shopify.country.toUpperCase() : null;

    if (countryCode && flagMap[countryCode]) {
      flagImg.src = flagMap[countryCode];
    } else if (retries > 0) {
      setTimeout(() => updateFlagWhenReady(retries - 1), 200); // Retry every 200ms
    } else {
      console.warn('Country not detected or flag not found after multiple retries');
    }
  }

  updateFlagWhenReady();
});

document.addEventListener('DOMContentLoaded', function () {
  // Inject modal HTML
  const modalHTML = `
    <div id="lang-modal" class="lang-modal">
      <div class="lang-modal-content">
        <span class="close-lang">&times;</span>
        <h3>Choose Country</h3>
        <div class="lang-modal-columns">
        <ul>
          <li><a href="#" data-domain="soundstorexl.dk"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/denmark.png?v=1742990123" alt="Danish">Denmark</a></li>
          <li><a href="#" data-domain="soundstorexl.se"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/sweden.png?v=1742990968" alt="Swedish">Sweden</a></li>
          <li><a href="#" data-domain="soundstorexl.no"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/norway.png?v=1742991092" alt="Norway">Norway</a></li>
          <li><a href="?country=nl"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0910/4090/7587/files/netherlands.png?v=1746438517" alt="EU">Netherlands</a></li>
          <li><a href="?country=fi"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/findland.png?v=1742991571" alt="findland">Finland</a></li>
          <li><a href="?country=de"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/germany.png?v=1742990123" alt="German">Germany</a></li>
          <li><a href="?country=fr"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/france.png?v=1742992825" alt="France">France</a></li>
          <li><a href="?country=it"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/flag.png?v=1742992824" alt="Italy">Italy</a></li>
          <li><a href="?country=es"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/world.png?v=1742992825" alt="Spain">Spain</a></li>
         </ul>
         <ul>
          <li><a href="?country=ee"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Estonia_svg.png?v=1746440898" alt="Estonia">Estonia</a></li>
          <li><a href="?country=lv"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0910/4090/7587/files/latvia.png?v=1746441665" alt="latvia">Latvia</a></li>
          <li><a href="?country=pl"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Poland.png?v=1746447118" alt="poland">Poland</a></li>
          <li><a href="?country=lt"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Lithuania.png?v=1746448397" alt="Lithuania">Lithuania</a></li>
          <li><a href="?country=at"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Austria_svg.png?v=1746448445" alt="Austria">Austria</a></li>
          <li><a href="?country=be"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Belgium.png?v=1746448509" alt="Belgium">Belgium</a></li>
          <li><a href="?country=lu"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Luxembourg_svg.png?v=1746448566" alt="Luxembourg">Luxembourg</a></li>
          <li><a href="?country=cz"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_the_Czech_Republic_svg.webp?v=1746448625" alt="Czech">Czech Republic</a></li>
        </ul>
        </div>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML('beforeend', modalHTML);

  // Inject styles
  const style = document.createElement('style');
  style.innerHTML = `
.lang-modal {
  display: none;
  position: fixed;
  z-index: 9999;
  top: 0; left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  overflow: auto;
}

.lang-modal-content {
  position: relative;
  background: #FAF9F6;
  max-width: 600px;
  margin: 5% auto;
  padding: 30px 20px 20px;
  border-radius: 10px;
  text-align: center;
}


.lang-modal-content h3 {
  margin-top: 0;
  text-align: center;
}

.lang-modal-content ul {
  list-style: none;
  padding: 0;
  margin: 20px 0 0;
}

.lang-modal-content li {
  margin: 10px 0;
  display: flex;
  align-items: center;
}

.lang-modal-content a {
  color: #000;
  text-decoration: none;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 10px;
}

.lang-modal-content a:hover {
  text-decoration: underline;
}

.close-lang {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  color: #333;
}


.lang-flag {
  width: 24px;
  height: 16px;
  object-fit: cover;
  border-radius: 2px;
}

.lang-modal-columns {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.lang-modal-columns ul {
  flex: 1 1 45%;
  padding: 0;
  margin: 0;
  list-style: none;
}

  `;
  document.head.appendChild(style);

  // Event logic
  const trigger = document.getElementById('open-lang-selector');
  const closeLang = () => document.getElementById('lang-modal').style.display = 'none';

  if (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementById('lang-modal').style.display = 'block';
    });
  }

  document.body.addEventListener('click', function (e) {
    if (e.target.classList.contains('close-lang') || e.target.id === 'lang-modal') {
      closeLang();
    }
  });

  // Redirect logic
  document.body.addEventListener('click', function (e) {
    if (e.target.matches('.lang-modal-content a[data-domain]')) {
      e.preventDefault();
      const newDomain = e.target.getAttribute('data-domain');
      const currentPath = window.location.pathname;
      const safePaths = ['/pages/blogs', '/pages/faq', '/apps', '/policies'];
      const isSafe = safePaths.some(path => currentPath.startsWith(path) || currentPath.includes(path));
      const newUrl = isSafe
        ? `https://${newDomain}${currentPath}${window.location.search}${window.location.hash}`
        : `https://${newDomain}`;
      window.location.href = newUrl;
    }
  });
});